import { render } from "./BandhooStats.vue?vue&type=template&id=ec8f1164&scoped=true"
import script from "./BandhooStats.vue?vue&type=script&lang=js"
export * from "./BandhooStats.vue?vue&type=script&lang=js"

import "./BandhooStats.vue?vue&type=style&index=0&id=ec8f1164&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec8f1164"]])

export default __exports__